import { PromoEntityStrapi } from '@promo/const';
import { StateUtils } from '@spartacus/core';
import { PROMO_ENTITY } from '../promo-state';
export const LOAD_PROMO = '[Promo] Promo Load';
export const LOAD_PROMO_FAIL = '[Promo] Promo Load Fail';
export const LOAD_PROMO_SUCCESS = '[Promo] Promo Load Success';

export class PromoLoad extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_PROMO;

  constructor(public payload: string) {
    super(PROMO_ENTITY);
  }
}

export class PromoLoadFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_PROMO_FAIL;

  constructor(public payload: any) {
    super(PROMO_ENTITY, payload);
  }
}

export class PromoLoadSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_PROMO_SUCCESS;

  constructor(public payload: PromoEntityStrapi | null) {
    super(PROMO_ENTITY);
  }
}

export type PromoLoadAction = PromoLoad | PromoLoadFail | PromoLoadSuccess;
